import { LeaseSpace } from '@centecomm/portal-service';
import { Address, PersonalInformation, IdentificationType, BusinessInformation } from './Types';
import { FCRA } from './Types/FCRA';
import { LeasingApplication } from './Types/LeasingApplication';

export enum LeasingActions {
    SET_LOADING_APPLICATION = 'LEASING_SET_LOADING_APPLICATION',
    SET_LOAD_APPLICATION = 'LEASING_SET_LOAD_APPLICATION',
    SET_PAUSE_APPLICATION = 'LEASING_SET_PAUSE_APPLICATION',
    SET_START_APPLICATION = 'LEASING_SET_START_APPLICATION',
    SET_APPLICATION_PERSONAL_INFORMATION = 'LEASING_APPLICATION_SET_PERSONAL_INFORMATION',
    SET_APPLICATION_BUSINESS_INFORMATION = 'LEASING_APPLICATION_SET_BUSINESS_INFORMATION',
    SET_APPLICATION_ADDRESS = 'LEASING_APPLICATION_SET_ADDRESS',
    SET_APPLICATION_IDENTIFICATION = 'LEASING_SET_IDENTIFICATION',
    SET_FCRA = 'LEASING_SET_FCRA',
    SET_LEASING_PROPERTIES = 'SET_LEASING_PROPERTIES',
    SET_LEASING_PROPERTIES_LOADED = 'SET_LEASING_PROPERTIES_LOADED',
}

interface SetIdentificationAction {
    type: LeasingActions.SET_APPLICATION_IDENTIFICATION;
    payload: IdentificationType;
}

interface LeasingLoadingApplicationAction {
    type: LeasingActions.SET_LOADING_APPLICATION;
}

interface LeasingLoadApplicationAction {
    type: LeasingActions.SET_LOAD_APPLICATION;
    payload: LeasingApplication;
}

interface LeasingPauseApplicationAction {
    type: LeasingActions.SET_PAUSE_APPLICATION;
}

interface LeasingStartApplicationAction {
    type: LeasingActions.SET_START_APPLICATION;
}

interface LeasingApplicationSetPersonalInformationAction {
    type: LeasingActions.SET_APPLICATION_PERSONAL_INFORMATION;
    payload: PersonalInformation;
}

interface LeasingApplicationSetBusinessInformationAction {
    type: LeasingActions.SET_APPLICATION_BUSINESS_INFORMATION;
    payload: BusinessInformation;
}

interface LeasingApplicationSetAddressAction {
    type: LeasingActions.SET_APPLICATION_ADDRESS;
    payload: Address;
}

interface LeasingSetFCRA {
    type: LeasingActions.SET_FCRA;
    payload: FCRA;
}

interface SetLeasingPropertiesAction {
    type: LeasingActions.SET_LEASING_PROPERTIES;
    payload: LeaseSpace[];
}

interface SetLeasingPropertiesLoadedAction {
    type: LeasingActions.SET_LEASING_PROPERTIES_LOADED;
}

export type LeasingActionTypes =
    | LeasingLoadingApplicationAction
    | LeasingLoadApplicationAction
    | LeasingPauseApplicationAction
    | LeasingStartApplicationAction
    | LeasingApplicationSetPersonalInformationAction
    | LeasingApplicationSetBusinessInformationAction
    | LeasingApplicationSetAddressAction
    | SetIdentificationAction
    | LeasingSetFCRA
    | SetLeasingPropertiesAction
    | SetLeasingPropertiesLoadedAction;
